export default {
  title: 'Tableau de bord',
  description: 'Vue d\'ensemble des opérations industrielles',
  widgets: {
    incidentsTrend: 'Tendance des incidents',
    actionsByStatus: 'Actions par statut',
    oeeOverview: 'Vue d\'ensemble TRS',
    productionLines: 'État des lignes de production',
    criticalAlerts: 'Alertes critiques',
    actionsCompletion: 'Taux de complétion des actions',
    incidentsBySeverity: 'Incidents par sévérité',
    productionToday: 'Production du jour'
  },
  stats: {
    activeIncidents: 'Incidents actifs',
    overdueActions: 'Actions en retard',
    avgOee: 'TRS moyen',
    runningLines: 'Lignes en cours'
  },
  periods: {
    today: 'Aujourd\'hui',
    week: 'Cette semaine',
    month: 'Ce mois',
    year: 'Cette année'
  },
  noData: 'Aucune donnée disponible'
}
